import { useMutation } from 'react-query';
import {useWordPressStore} from "../../store/wordpress.store";
import {WordpressApi} from "../../api/wordpress.api";

export const useWordPressMaterials = () => {
    const setMaterials = useWordPressStore((state) => state.setMaterials);

    return useMutation(WordpressApi.getMaterials, {
        onSuccess: (data) => {
            setMaterials(data);
        },
        onError: (error) => {
            console.error('Login failed:', error);
        },
    });
};